import React, { Fragment } from 'react';

import { NumberUtils } from '../../../../common/numberUtils';
import Skeleton from 'react-loading-skeleton';

export interface MeterIndexCardProps {
  title: string;
  value: number;
  unit?: string;
  type?: 'consumption' | 'injection';
  isLoading?: boolean;
}
export default function MeterIndexCard({
  title,
  value,
  unit,
  type,
  isLoading,
}: MeterIndexCardProps) {
  return (
    <Fragment>
      {isLoading ? (
        <Skeleton width={250} height={100} />
      ) : (
        <div className={`meter-index-card ${type ? `meter-index-card__${type}` : ''}`}>
          <div className="meter-index-card__title">{title}</div>
          <div className="meter-index-card__value">
            {NumberUtils.parse(value, 2)}

            {unit && <span className="meter-index-card__value__unit">{unit}</span>}
          </div>
        </div>
      )}
    </Fragment>
  );
}
